/**
 * Determine if the current environment is a server-side environment.
 *
 * @returns {boolean} True if the current environment is a server-side environment.
 */
export function isServerSide(): boolean {
	try {
		if (
			typeof process !== "undefined" &&
			typeof process.versions?.node === "string"
		) {
			return true;
		}
		return false;
	} catch {
		return false;
	}
}
